import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
	selector: 'app-breadcrumb',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './breadcrumb.html',
	styleUrl: './breadcrumb.scss',
})
export class BreadcrumbComponent {
	slug = input.required<string>();
	selectedPath = input<string | null>(null);
	selectedNodeType = input<'project' | 'chapter' | 'scene' | 'image' | null>(null);

	navigate = output<string>();

	protected items = computed(() => {
		const path = this.selectedPath();
		const nodeType = this.selectedNodeType();
		const slug = this.slug();
		if (!path) return [{ label: slug, clickable: true, action: 'project' as const }];

		const parts: { label: string; clickable: boolean; action: string }[] = [
			{ label: slug, clickable: true, action: 'project' },
		];

		// Chapter virtual path: chapter:<slug>
		if (nodeType === 'chapter') {
			const chSlug = path.replace('chapter:', '');
			parts.push({ label: chSlug, clickable: false, action: '' });
			return parts;
		}

		// Scene: /projects/:slug/chapters/:ch/scenes/:sc/scene.json
		const sceneMatch = path.match(/\/chapters\/([^/]+)\/scenes\/([^/]+)\//);
		if (sceneMatch) {
			parts.push({ label: sceneMatch[1], clickable: true, action: `chapter:${sceneMatch[1]}` });
			parts.push({ label: sceneMatch[2], clickable: false, action: '' });
			parts.push({ label: 'scene.json', clickable: false, action: '' });
			return parts;
		}

		// Chapter image: /projects/:slug/chapters/:ch/images/:img/image.json
		const chImgMatch = path.match(/\/chapters\/([^/]+)\/images\/([^/]+)\//);
		if (chImgMatch) {
			parts.push({ label: chImgMatch[1], clickable: true, action: `chapter:${chImgMatch[1]}` });
			parts.push({ label: chImgMatch[2], clickable: false, action: '' });
			parts.push({ label: 'image.json', clickable: false, action: '' });
			return parts;
		}

		// Project-level scene: /projects/:slug/scenes/:sc/scene.json
		const pSceneMatch = path.match(/\/projects\/[^/]+\/scenes\/([^/]+)\//);
		if (pSceneMatch) {
			parts.push({ label: pSceneMatch[1], clickable: false, action: '' });
			parts.push({ label: 'scene.json', clickable: false, action: '' });
			return parts;
		}

		// Project-level image: /projects/:slug/images/:img/image.json
		const pImgMatch = path.match(/\/images\/([^/]+)\//);
		if (pImgMatch) {
			parts.push({ label: pImgMatch[1], clickable: false, action: '' });
			parts.push({ label: 'image.json', clickable: false, action: '' });
			return parts;
		}

		parts.push({ label: 'project.json', clickable: false, action: '' });
		return parts;
	});

	protected onClick(action: string): void {
		this.navigate.emit(action);
	}
}
